import React from 'react';
import { IOverallMetricTooltip } from './interfaces';
import { Typography } from '@navi/web-ui/lib/primitives';
import { getMetricValue } from './constants';

const OverallMetricTooltip: React.FC<IOverallMetricTooltip> = ({ data }) => {
  const { currentValue, lmsdValue, metricFormat } = data || {};
  const currentFormattedValue = getMetricValue(currentValue, metricFormat, false);
  const lmsdFormattedValue = getMetricValue(lmsdValue, metricFormat, false);
  return (
    <div>
      <Typography variant="p4">Current: {currentFormattedValue}</Typography>
      <Typography variant="p4">LMSD: {lmsdFormattedValue}</Typography>
    </div>
  );
};

export default OverallMetricTooltip;
